"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableStatusColor = exports.TABLE_STATUSES = exports.AWAITING_SUBSCRIPTION_PAYMENT = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var AWAITING_SUBSCRIPTION_PAYMENT = "AWAITING-SUBSCRIPTION-PAYMENT";
exports.AWAITING_SUBSCRIPTION_PAYMENT = AWAITING_SUBSCRIPTION_PAYMENT;
var tableStatusColor = function (status) {
    if (["ACTIVE", "COMPLETED", "FUlFILLED", "PROCESSED", "ORDERED", "READY", "ARRIVED", "DELIVERED", "ONLINE", "AVAILABLE", "COMPLETE"].includes(status)) {
        return "success";
    }
    if (["SUSPENDED", "ABANDONED", "RETURNED-BY-CUSTOMER", "BLOCKED"].includes(status)) {
        return "danger";
    }
    if ([
        "AWAITING-SIGNUP",
        "DORMANT",
        "PROCESSING",
        "CHECKED-OUT",
        "POS-ORDERED",
        "COLLECTED",
        "DELIVERY-READY",
        "PARTIALLY-DELIVERED",
        "AWAITING-EMAIL-CONFIRMATION",
    ].includes(status)) {
        return "warning";
    }
    return "default";
};
exports.tableStatusColor = tableStatusColor;
var TABLE_STATUSES = function (statusString) {
    if (!statusString)
        return "";
    var status = statusString.toUpperCase();
    return ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap text-xs capitalize", color: tableStatusColor(status), size: "sm", variant: "soft", children: status }));
};
exports.TABLE_STATUSES = TABLE_STATUSES;
